import API from 'src/api'
import { http } from 'src/boot/axios'

// Los servicios solo retornan la llamada de axios; el manejo de exito/error y
// cualquier normalizacion vive en el store (ver stores/exhibitions/actions.js).
const exhibitionsService = {
  URL: API.GRAPHQL_URL + 'exhibitions',
  TYPES_URL: API.GRAPHQL_URL + 'exhibition-types',
  PLACES_URL: API.GRAPHQL_URL + 'exhibition-places',
  PRODUCTS_IMPORT_URL: API.GRAPHQL_URL + 'exhibitions/products/import',

  fetchFiltered (params) {
    return http.get(`${this.URL}/filter`, { params })
  },
  getById (id) {
    return http.get(`${this.URL}/${id}`)
  },
  // Las evidencias viajan como multipart (archivos binarios), no base64 en JSON.
  create (formData) {
    return http.post(`${this.URL}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  changeStatus (formData) {
    return http.post(`${this.URL}/changeStatus`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  addEvidence (formData) {
    return http.post(`${this.URL}/addEvidence`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  deleteEvidence (evidenceId) {
    return http.delete(`${this.URL}/evidence/${evidenceId}`)
  },
  fetchTypes () {
    return http.get(`${this.TYPES_URL}`)
  },
  fetchPromoters (params) {
    return http.get(`${this.URL}/promoters`, { params })
  },
  fetchProducts (params) {
    return http.get(`${this.URL}/products`, { params })
  },
  importProducts (formData) {
    return http.post(`${this.PRODUCTS_IMPORT_URL}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  // Administracion de catalogos (Admin -> Catalogos -> Exhibiciones)
  createProduct (payload) {
    return http.post(`${this.URL}/products`, payload)
  },
  updateProduct (id, payload) {
    return http.put(`${this.URL}/products/${id}`, payload)
  },
  deleteProduct (id) {
    return http.delete(`${this.URL}/products/${id}`)
  },
  createType (payload) {
    return http.post(`${this.TYPES_URL}`, payload)
  },
  updateType (id, payload) {
    return http.put(`${this.TYPES_URL}/${id}`, payload)
  },
  deleteType (id) {
    return http.delete(`${this.TYPES_URL}/${id}`)
  },
  fetchPlaces () {
    return http.get(`${this.PLACES_URL}`)
  },
  createPlace (payload) {
    return http.post(`${this.PLACES_URL}`, payload)
  },
  updatePlace (id, payload) {
    return http.put(`${this.PLACES_URL}/${id}`, payload)
  },
  deletePlace (id) {
    return http.delete(`${this.PLACES_URL}/${id}`)
  }
}

export default exhibitionsService
